import React, { useEffect, useState } from "react";
import PensionPage from "../../../../../entities/DashboardPage/HRModule/Pension/PensionHome";
import AuthService from "../../../../../api/AuthService";
import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
import { useAlert } from "../../../../../context/AlertContext";

const Pension = () => {
  const [data,  setData] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(1);
  const { showAlert } = useAlert();
  const [pensionType, setPensionType] = useState([]);
  const [employeeData,setEmployeeData] = useState();

  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);


  useEffect(() => {
    getPension("","",page,);
    getPensionType();
  },[page])

  const getPension = async (text,sort,page,) => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getEmpPension(text,sort,page);
      if (result?.success) {
        // if (result?.data?.length > 0) {
        setData(result?.data?.pension);
        setTotal(result?.data?.total);

        // }
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleDelete = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.deleteEmpPension(id);
      if (result?.success === true) {
        LoaderHelper.loaderStatus(false);

        getPension();
        // console.slog(result?.success,"new employe data ---")
      } else {
        LoaderHelper.loaderStatus(false);
        // showAlert(result?.message,"error")
        
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    //   showAlert(error,"success")
      // Handle error
      //   alertErrorMessage(error);
    }
  };
  const handleFilter = (text,sort) => {
    text ? getPension(text):sort ? getPension("",sort):null
  }
  const handlePension = async (employeeId, pensionPaid, type, employeeAmount, employeeRate, employeeSalary,employerAmount, employerRate,  employerSalary) => {
    setLoading(true);
    try {
      const result = await AuthService.handleEmpPension(employeeId, pensionPaid, type, employeeAmount, employeeRate, employeeSalary,employerAmount, employerRate,  employerSalary);
      if (result?.success === true) {
        setLoading(false);
        getPension();
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error, "success");
    }
  };

  const getPensionType = async() =>{
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getPensionType();
      if (result?.success) { 
        setPensionType(result?.data);

        LoaderHelper.loaderStatus(false);
        
        // console.log(result,"result getemployee")
      } else {
        LoaderHelper.loaderStatus(false);
        // console.log(result?.message, "kjshakjh");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      // console.error("Error occurred:", error);
    }
  };
  const SearchEmployee = async(text) =>{
    setLoading(true);
    try {
      const result = await AuthService.getEmployeeList(text);
      if (result?.success) { 
        setEmployeeData(result?.data?.employees);
        setLoading(false);
        
        // console.log(result,"result getemployee")
      } else {
        setLoading(false);
        // console.log(result?.message, "kjshakjh");
      }
    } catch (error) {
      setLoading(false);
      // console.error("Error occurred:", error);
    }
  };


  return (
    <PensionPage page={page} total={total} handleEmployee={SearchEmployee} pensionType={pensionType} employeeData ={employeeData} setPage={setPage} data={data} handleFilter={handleFilter} handleDelete={handleDelete} handleAdd={handlePension} loading={loading} open={open} setOpen={setOpen}/>
  )

}

export default Pension;
